// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-popover-content .view-details {
  font-family: Roboto;
  border-radius: 5px;
  background: #f0f0f0 !important;
  display: flex;
  padding: 10px 14px;
  justify-content: center;
  align-items: center;
  color: #0a0f0d !important;
  gap: 8px;
  border: none;
  margin-top: 6px;
}

.notification-popover-content .description {
  font-family: Roboto;
  color: #0a0f0d;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 6px;
  display: flex;
  justify-content: space-between;
}

.notification-popover-content .notify-date {
  font-size: 13px;
  align-content: center;
}
.notification-popover-content .image-container {
  margin-top: 2rem;
  justify-self: anchor-center;
}
.no-notifications-icon {
  width: 22.5vw;
  height: 191px;
  padding: 0;
}
.content-section .no-new-header {
  font-family: Roboto;
  color: #0a0f0d;
  font-size: 19px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.content-section {
  text-align: center;
  margin-bottom: 66px;
}
.content-section .sub-message {
  color: #5b5e5d;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
  padding: 7px auto 66px auto;
}
.new-notify-badge {
  box-shadow: 2px 2px 2px 2px rgba(216, 90, 115, 0.2) !important;
}
.description .ant-badge-status-dot {
  width: 10px !important;
  height: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/notification-popover-content/NotificationPopoverContent.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,aAAa;EACb,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,8DAA8D;AAChE;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":[".notification-popover-content .view-details {\n  font-family: Roboto;\n  border-radius: 5px;\n  background: #f0f0f0 !important;\n  display: flex;\n  padding: 10px 14px;\n  justify-content: center;\n  align-items: center;\n  color: #0a0f0d !important;\n  gap: 8px;\n  border: none;\n  margin-top: 6px;\n}\n\n.notification-popover-content .description {\n  font-family: Roboto;\n  color: #0a0f0d;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 6px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.notification-popover-content .notify-date {\n  font-size: 13px;\n  align-content: center;\n}\n.notification-popover-content .image-container {\n  margin-top: 2rem;\n  justify-self: anchor-center;\n}\n.no-notifications-icon {\n  width: 22.5vw;\n  height: 191px;\n  padding: 0;\n}\n.content-section .no-new-header {\n  font-family: Roboto;\n  color: #0a0f0d;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.content-section {\n  text-align: center;\n  margin-bottom: 66px;\n}\n.content-section .sub-message {\n  color: #5b5e5d;\n  text-align: center;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18.2px;\n  padding: 7px auto 66px auto;\n}\n.new-notify-badge {\n  box-shadow: 2px 2px 2px 2px rgba(216, 90, 115, 0.2) !important;\n}\n.description .ant-badge-status-dot {\n  width: 10px !important;\n  height: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
